import Vue from 'vue'
import VueI18n from 'vue-i18n'
// Languages json
import ES from '@/languages/ES/translations.json'
import EN from '@/languages/EN/translations.json'

// Detect language navigator
let languageNavigator = navigator.language.split('-')[0].toUpperCase()

// Validate navigator
if (languageNavigator !== 'EN' && languageNavigator !== 'ES') languageNavigator = 'EN'

// LocalStorage
import persistentData from '@/plugins/persistentData'
persistentData.setData('language', languageNavigator)

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: languageNavigator,
  fallbackLocale: "EN",
  messages: {
    ES,
    EN
  }
})